/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type ExpiryOnCell_ClaimCodeFragment = { __typename: 'MultiClaimCodeDocument', id: string, expiry?: any | null };

export const ExpiryOnCell_ClaimCodeFragmentDoc = gql`
    fragment ExpiryOnCell_claimCode on MultiClaimCodeDocument {
  id
  expiry
}
    `;